import Box from "@mui/material/Box";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import Button from "@mui/material/Button";
import Chip from "@mui/material/Chip";
import type { ArticleTopicInfo, PublicationItemInfo } from "./useTaskDetailSubscription";
import type { PreviewSibling } from "./useTaskDetailActions";
import { ArticleVariations } from "./ArticleVariations";
import { STATUS_COLORS } from "./ArticleTopicsSection";

export function ArticleTopicRow(props: {
  topic: ArticleTopicInfo;
  publicationItems: PublicationItemInfo[] | null;
  onRegenerate: (unitId: string) => void;
  regenerateState: { kind: string };
  onViewVariation: (variationId: string, siblings: PreviewSibling[]) => void;
}) {
  const { topic } = props;
  const hasPublication = props.publicationItems !== null;
  const canRegenerate = !hasPublication && (topic.status === "completed" || topic.status === "failed");

  return (
    <>
      <TableRow>
        <TableCell>{topic.generalTopic ?? "—"}</TableCell>
        <TableCell>{topic.spintaxTitle ?? "—"}</TableCell>
        <TableCell align="right">{topic.variations.length}</TableCell>
        <TableCell>
          <Chip label={topic.status} size="small" color={STATUS_COLORS[topic.status]} />
        </TableCell>
        <TableCell>
          {canRegenerate && (
            <Button
              size="small"
              variant="outlined"
              onClick={() => props.onRegenerate(topic.id)}
              disabled={props.regenerateState.kind === "loading"}
            >
              {props.regenerateState.kind === "loading" ? "…" : "Перегенерировать"}
            </Button>
          )}
        </TableCell>
      </TableRow>
      {topic.variations.length > 0 && (
        <TableRow>
          <TableCell colSpan={5} sx={{ pt: 0.5, pb: 1, pl: 4, pr: 2, borderBottom: "none" }}>
            <Box sx={{ bgcolor: "action.hover", borderRadius: 1, px: 1.5, py: 1 }}>
              <ArticleVariations
                variations={topic.variations}
                publicationItems={props.publicationItems}
                onViewVariation={props.onViewVariation}
              />
            </Box>
          </TableCell>
        </TableRow>
      )}
    </>
  );
}
